/* eslint-disable @typescript-eslint/no-explicit-any */

import { Typography, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Nunito_Sans, Lato } from '@next/font/google'
import clsx from 'clsx'
import Header from 'src/components/pages/fundraise/header/Header'
import { RootState } from 'src/store/store'
import NotAlone from 'src/components/shared/modules/notAlone/NotAlone'
import WhatSkill from 'src/components/pages/fundraise/whatSkill/WhatSkill'
import useStyles from 'src/styles/pages/fundraise/Style'
import WhatHappens from 'src/components/pages/fundraise/whatHappens/WhatHappens'
import DonateSkill from 'src/components/pages/fundraise/donateSkill/DonateSkill'
import {
  contentType,
  DonateSkillContent,
  TestimonialsContent,
  WhatSkillContent,
} from 'src/types/components/shared/atom'
import bg from 'src/assets/images/fundraise/donate-skill.jpg'
// import { useGetPageByNameQuery } from 'src/store/ApiCall/pagesAPI'
import { heroHeaderContent } from 'src/types/components/shared/atom'
import VolunteerForm from 'src/components/pages/volunteerForm'
import Skeleton from 'src/components/shared/modules/skeleton'
import HeadTag from 'src/components/layout/head'
import { DonateSkillFormI } from 'src/types/store'
import { apiFetch } from '../../service/api.service'

const nunitoSans = Nunito_Sans({
  weight: ['400', '700', '800'],
  subsets: ['latin'],
})

const lato = Lato({
  weight: '400',
  subsets: ['latin'],
})

interface IProps {
  data: any
}

const DonateSkills: React.FC<IProps> = ({ data }) => {
  const { classes } = useStyles()
  // const { data } = useGetPageByNameQuery('donateSkills')
  const [header, setHeader] = useState<heroHeaderContent>()
  const [testimonialContent, setTestimonialContent] =
    useState<TestimonialsContent>()
  const [whatSkillContent, setWhatSkillContent] = useState<WhatSkillContent>()
  const [whatHappenContent, setWhatHappenContent] = useState<{
    heading: string
    text: string
  }>()
  const [donateSkillContent, setDonateSkillContent] =
    useState<DonateSkillContent>()
  const [formData, setFormData] = useState<DonateSkillFormI>()
  useEffect(() => {
    if (data && data.data.length > 0) {
      const content = data.data[0].attributes
      const {
        heroHeader,
        testimonials,
        whatHappensOnceSubmittedAPledge,
        whatsSkillWeLookingFor,
        donateSkillForm,
      } = content

      //extracting header from data
      if (heroHeader) {
        const { primaryText, secondaryText, tertiaryText, headercard } =
          heroHeader
        const headerText: contentType = {
          content: {
            secondary: {
              content: secondaryText,
              variant: 'h3',
              type: 'secondary',
            },
            primary: {
              content: primaryText,
              variant: 'h1',
              type: 'primary',
            },
            tertiary: {
              content: tertiaryText,
              variant: 'subtitle1',
              type: 'tertiary',
            },
          },
          topics: [],
        }

        const headerContent: heroHeaderContent = {
          headerText: headerText,
          headerCard: {
            bg: bg,
            icon: headercard ? headercard.icon.data.attributes.url : undefined,
            heading: headercard?.heading,
            text: headercard?.text,
          },
        }
        setHeader(headerContent)
      }

      //extracting testimonials from data
      if (testimonials) {
        const { heading, text, testimonialCard } = testimonials
        const testimonialContent: TestimonialsContent = {
          heading: heading,
          text: text,
          cardData: testimonialCard.map((curr: any) => {
            return {
              img: curr.logo.data.attributes.url,
              name: curr.name,
              age: curr.age,
              description: curr.description,
              secondaryText: curr.secondText,
            }
          }),
        }
        setTestimonialContent(testimonialContent)
      }

      //extracting what kind of skill we are looking for from data
      if (whatsSkillWeLookingFor) {
        const { heading, text, card } = whatsSkillWeLookingFor
        const whatSkillContent: WhatSkillContent = {
          heading: heading,
          text: text,
          cardData: card.map((curr: any) => {
            return {
              icon: curr.icon.data.attributes.url,
              text: curr.text,
            }
          }),
        }
        setWhatSkillContent(whatSkillContent)
      }

      //extracting what happens once submitted a pledge from data
      if (whatHappensOnceSubmittedAPledge) {
        const { heading, text, donateSkills } = whatHappensOnceSubmittedAPledge

        const whatHappens = {
          heading: heading,
          text: text,
        }

        setWhatHappenContent(whatHappens)
        const {
          heading: donateHeading,
          text: donateText,
          subHeading,
          image,
          button,
        } = donateSkills

        const donateSkillContent: DonateSkillContent = {
          heading: donateHeading,
          secondaryHeading: subHeading,
          text: donateText,
          btn: {
            id: button.id,
            content: button.content,
            href: button.href ? button.href : '#',
          },
          img: image.data.attributes.url,
        }

        setDonateSkillContent(donateSkillContent)
      }

      if (donateSkillForm) setFormData(donateSkillForm)
    }
  }, [data])
  const zenMode = useSelector((state: RootState) => state.zenModeState.zenMode)

  return (
    <>
      <HeadTag
        title={data?.data[0].attributes.metaTitle}
        description={data?.data[0].attributes.metaDescription}
      />
      <Grid sx={{ marginTop: '130px' }}>
        {header ? (
          <Grid>
            <Header zenMode={zenMode} content={header} />
          </Grid>
        ) : (
          <Skeleton />
        )}

        {testimonialContent ? (
          <Grid>
            <NotAlone zenMode={zenMode} content={testimonialContent} />
          </Grid>
        ) : (
          ''
        )}

        {whatSkillContent ? (
          <Grid className={classes.container}>
            <WhatSkill zenMode={zenMode} content={whatSkillContent} />
          </Grid>
        ) : (
          ''
        )}

        {whatHappenContent ? (
          <Grid className={classes.container}>
            <WhatHappens content={whatHappenContent} />
          </Grid>
        ) : (
          ''
        )}

        {donateSkillContent ? (
          <Grid className={classes.containerWithNotMargin}>
            <DonateSkill zenMode={zenMode} content={donateSkillContent} />
          </Grid>
        ) : (
          ''
        )}

        <Grid container className={classes.volunteerFormComp}>
          <Grid
            id="donate_skill_form"
            container
            className={classes.volunteerFormInner}
          >
            <Grid item md={12} className={classes.textContainer}>
              <Typography
                component="h1"
                className={clsx(
                  nunitoSans.className,
                  classes.volunteerFormHeading
                )}
              >
                {formData?.heading}
              </Typography>
              <Typography
                component="h5"
                className={clsx(
                  lato.className,
                  classes.volunteerFormSubHeading
                )}
              >
                {formData?.description}
              </Typography>
              <Typography
                component="p"
                className={classes.volunteerFormBodyText}
              >
                {formData?.text}
              </Typography>
            </Grid>
            <Grid item md={12} className={classes.formContainer}>
              <Grid item md={12} className={classes.formInnerContainer}>
                {formData ? <VolunteerForm content={formData} /> : ''}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

// This gets called on every request
export async function getServerSideProps() {
  // Fetch data from external API
  const baseURL =
    process.env.NEXT_PUBLIC_BACKEND_URL ||
    'https://strapi-beta.ditchthelabel.org'
  const endPoint =
    process.env.NEXT_PUBLIC_SITE_LANGUAGE === 'en'
      ? `/api/article-schemas?filters[name][$eq]=donateSkills&populate=deep`
      : `/api/article-schemas?filters[name][$eq]=mx-donateSkills&populate=deep&locale=es-MX`
  const url = baseURL + endPoint

  const data = await apiFetch(url)

  // Pass data to the page via props
  return { props: { data } }
}
export default DonateSkills
